import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { CrmClientCommunication } from '../../crm/crm.model';
import { LogisticsProjectLookupComponent } from '../../logistics-projects/logistics-project-lookup.component';

@Component({
    selector: 'app-commercial-context-dialog',
    standalone: true,
    imports: [CommonModule, FormsModule, TranslocoPipe, ButtonModule, DialogModule, IftaLabelModule,
        InputGroupModule, InputGroupAddonModule, InputTextModule, SelectModule, TextareaModule,
        LogisticsProjectLookupComponent],
    templateUrl: './commercial-context-dialog.component.html',
    styleUrl: './commercial-context-dialog.component.css'
})
export class CommercialContextDialogComponent {
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Input() documentNumber = '';
    @Input() partyName = '';
    @Input() companyId?: number;
    @Input() crmClientId?: number;
    @Input() externalReference = '';
    @Output() externalReferenceChange = new EventEmitter<string>();
    @Input() dueDate = '';
    @Output() dueDateChange = new EventEmitter<string>();
    @Input() projectId: number | null = null;
    @Output() projectIdChange = new EventEmitter<number | null>();
    @Input() contactId: number | null = null;
    @Output() contactIdChange = new EventEmitter<number | null>();
    @Input() contacts: CrmClientCommunication[] = [];
    @Input() contactsLoading = false;
    @Input() lineComments: Array<{ lineId: number; description: string; comment: string }> = [];
    @Input() saving = false;
    @Input() error = '';
    @Output() save = new EventEmitter<void>();
}
